import { TierIIEmailTemplate } from "./tierIIEmailTemplate";
import { TemplateName } from "./types";
export class MailRoomFlexibleTemplate extends TierIIEmailTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.MailRoomFlexible;
    }
    subject({ communication }) {
        const { facilities, tierIIReports } = communication;
        const hasReports = tierIIReports && tierIIReports.length > 0;
        const hasFacilities = facilities && facilities.length > 0;
        // If you have reports, you should have facilities
        if (hasReports && !hasFacilities) {
            throw new Error("MailRoomFlexibleTemplate: hasReports is true but hasFacilities is false");
        }
        // Case 1: Has reports - use Tier II format
        if (hasReports) {
            return super.subject({ communication });
        }
        // Case 2: No reports, but facilities - use general communication format
        if (hasFacilities) {
            const prefix = this.getPrefix(null);
            const facilityNames = this.getFacilityNames(facilities);
            const shortReportingYear = this.getShortReportingYear(
            // Let's just init to the previous calendar year.
            // This is a hack because we can't get the current year from no-reports,
            // And, building with encamp-shared creates a bad dependency due to lack of ESM support.
            new Date().getFullYear() - 1);
            return `${prefix} - ${facilityNames} - RY${shortReportingYear}`;
        }
        // Case 3: No reports, no facilities - no subject
        return "";
    }
    text({ communication }) {
        const { facilities, tierIIReports, tenant } = communication;
        const hasReports = tierIIReports && tierIIReports.length > 0;
        const hasFacilities = facilities && facilities.length > 0;
        // If you have reports, you should have facilities
        if (hasReports && !hasFacilities) {
            throw new Error("MailRoomFlexibleTemplate: hasReports is true but hasFacilities is false");
        }
        // Case 1: No reports, no facilities - return empty
        if (!hasReports && !hasFacilities) {
            return "";
        }
        return super.text({ communication });
    }
}
//# sourceMappingURL=mailRoomFlexibleTemplate.js.map